import React, { Suspense } from 'react';

// TODO: Better way to import the polyfill
import 'intersection-observer';

import 'modern-css-reset';
import '@reach/dialog/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

import FullPageLoading from 'components/full-page-loading';
import { useAuth } from 'context/auth';

import 'styles/fonts.css';
import 'styles/variables.css';
import 'styles/globals.css';
import 'styles/ckeditor.css';

const { REACT_APP_VERSION, REACT_APP_API_URL, NODE_ENV } = process.env;

console.info('NNN env', NODE_ENV);
console.info('NNN app version: ', REACT_APP_VERSION);
console.info('NNN API: ', REACT_APP_API_URL);

const Public = React.lazy(() => import('./public'));
const Private = React.lazy(() => import('./private'));

function App() {
  const { user } = useAuth();
  return (
    <Suspense fallback={<FullPageLoading delay={300} header={false} />}>
      {user?.token ? <Private /> : <Public />}
    </Suspense>
  );
}

App.propTypes = {};

App.defaultProps = {};

export default App;
